import React from "react";
import axios from "axios";
import Question from './radios'
import { Link } from "gatsby"
import Radio from '@material-ui/core/Radio';

var globmbti = "";
var globgen = "";

class ContactForm extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = this.handleChange;
    this.state = {
      archetype: "unknown - error occured",
      extraversion: 0,
      agreeablenes: 0,
      constientiousness: 0,
      emotional: 0,
      intellect: 0,
      vals_arr: [],
      names_arr: [],
      best: "",
      ok: false,
      age: -1,
      mbti1: "x",
      mbti2: "x",
      mbti3: "x",
      mbti4: "x",
      gender: "y",
    };
  }


  handleFormSubmit = e => {

    //e.preventDefault();




  };


  getMBTICode() {
    let ie =  this.state.q74;
    let sn = this.state.q75;
    let tf = this.state.q76;
    let pj = this.state.q77;
    let gen = this.state.q78;

    if (gen) {
      if (gen == "1") {
        globgen = "M";
      } else if (gen == "2") {
        globgen = "F";
      } else {
        globgen = "X";
      }
    } else {
      globgen = "X";
    }

    let s = "";
    if (ie) {
      if (ie == "1") {
        s = s+"I";
      } else {
        s = s+"E";
      }
    } else {
      s = s+"X";
    }
    if (sn) {
      if (sn == "1") {
        s = s+"S";
      } else {
        s = s+"N";
      }
    } else {
      s = s+"X";
    }
    if (tf) {
      if (tf == "1") {
        s = s+"T";
      } else {
        s = s+"F";
      }
    } else {
      s = s+"X";
    }
    if (pj) {
      if (ie == "1") {
        s = s+"P";
      } else {
        s = s+"J";
      }
    } else {
      s = s+"X";
    }
    globmbti = s;
  }

  invert(num) {
    var c = 0;
    if (num == "1") c=5;
    if (num == "2") c=4;
    if (num == "3") c=3;
    if (num == "4") c=2;
    if (num == "5") c=1;
    return c;
  }


  componentDidUpdate() {
  }


  //handle changing fields

    handleChange = (e, field) => {

      this.setState(e);
      this.calculateArchetype();
      //this.setState({[e.target.name]: e.target.value})
    };

    everthingOK(vals_arr) {
        this.setState(
        { ok: !vals_arr.includes(NaN)}
      );

      this.getMBTICode();
    };



    calculateArchetype() {
        var extraversion =    parseInt(this.state.q1) +   parseInt(this.state.q11) +parseInt(this.state.q21) +parseInt(this.state.q31) +parseInt(this.state.q41)
                          +   this.invert(this.state.q6) + this.invert(this.state.q16) + this.invert(this.state.q26) + this.invert(this.state.q36) + this.invert(this.state.q46);

        var agreeablenes =   parseInt(this.state.q7) +   parseInt(this.state.q17) +parseInt(this.state.q27) +parseInt(this.state.q37) +parseInt(this.state.q42)   +parseInt(this.state.q47) +
                          +   this.invert(this.state.q2) + this.invert(this.state.q12) + this.invert(this.state.q22) + this.invert(this.state.q32);

        var constientiousness =   parseInt(this.state.q3) +   parseInt(this.state.q13) +parseInt(this.state.q23) +parseInt(this.state.q33) +parseInt(this.state.q43)   +parseInt(this.state.q48) +
                          +   this.invert(this.state.q8) + this.invert(this.state.q18) + this.invert(this.state.q28) + this.invert(this.state.q38);

        var emotional =       parseInt(this.state.q9) +   parseInt(this.state.q19) +
                          +   this.invert(this.state.q4) + this.invert(this.state.q14) + this.invert(this.state.q24) + this.invert(this.state.q29) + this.invert(this.state.q34) + this.invert(this.state.q39) + this.invert(this.state.q44) + this.invert(this.state.q49);

        var intellect =      parseInt(this.state.q5) +   parseInt(this.state.q15) +parseInt(this.state.q25) +parseInt(this.state.q35) +parseInt(this.state.q40) +  parseInt(this.state.q45) +parseInt(this.state.q50) +
                          +   this.invert(this.state.q10) + this.invert(this.state.q20) + this.invert(this.state.q30);


        var vals_arr = [extraversion, agreeablenes, constientiousness, emotional, intellect]
        var names_arr = ["extraversion", "agreeablenes", "constientiousness", "emotional stability", "intellect"]
        var indexOfMaxValue = vals_arr.reduce((iMax, x, i, arr) => x > arr[iMax] ? i : iMax, 0);

        this.setState({
          vals_arr: vals_arr,
          names_arr: names_arr,
          best: names_arr[indexOfMaxValue],
          extraversion: extraversion,
          agreeablenes: agreeablenes,
          constientiousness: constientiousness,
          emotional: emotional,
          intellect: intellect,
          age: this.state.q73,
          mbti1: this.state.q74,
          mbti2: this.state.q75,
          mbti3: this.state.q76,
          mbti4: this.state.q77,
          gender: this.state.q78,
        });

        console.log("E:" + this.state.extraversion);
        console.log("A:" + this.state.agreeablenes);
        console.log("C:" + this.state.constientiousness);
        console.log("E:" + this.state.emotional);
        console.log("I:" + this.state.intellect);
        this.everthingOK(vals_arr);

    }





  render() {

    return (
      <div className="form-wrapper">
        <div>
          <form action={this.state.best}>
          <Question text="I am the life of the party." prefix="q1" onChange={this.myRef}/>
          <Question text="I feel little concern for others." prefix="q2" onChange={this.myRef}/>
          <Question text="I am always prepared." prefix="q3" onChange={this.myRef}/>
          <Question text="I get stressed out easily." prefix="q4" onChange={this.myRef}/>
          <Question text="I have a rich vocabulary." prefix="q5" onChange={this.myRef}/>
          <Question text="I don't talk a lot." prefix="q6" onChange={this.myRef}/>
          <Question text="I am interested in people." prefix="q7" onChange={this.myRef}/>
          <Question text="I leave my belongings around." prefix="q8" onChange={this.myRef}/>
          <Question text="I am relaxed most of the time." prefix="q9" onChange={this.myRef}/>
          <Question text="I have difficulty understanding abstract ideas." prefix="q10" onChange={this.myRef}/>
          <Question text="I feel comfortable around people." prefix="q11" onChange={this.myRef}/>
          <Question text="I insult people." prefix="q12" onChange={this.myRef}/>
          <Question text="I pay attention to details." prefix="q13" onChange={this.myRef}/>
          <Question text="I worry about things." prefix="q14" onChange={this.myRef}/>
          <Question text="I have a vivid imagination." prefix="q15" onChange={this.myRef}/>
          <Question text='I stay in the background.' prefix="q16" onChange={this.myRef}/>
          <Question text="I sympathize with others' feelings." prefix="q17" onChange={this.myRef}/>
          <Question text="I make a mess of things." prefix="q18" onChange={this.myRef}/>
          <Question text="I seldom feel gloomy." prefix="q19" onChange={this.myRef}/>
          <Question text="I am not interested in abstract ideas." prefix="q20" onChange={this.myRef}/>
          <Question text="I start conversations." prefix="q21" onChange={this.myRef}/>
          <Question text="I am not interested in other people's problems." prefix="q22" onChange={this.myRef}/>
          <Question text="I get chores done right away." prefix="q23" onChange={this.myRef}/>
          <Question text="I am easily disturbed." prefix="q24" onChange={this.myRef}/>
          <Question text="I have excellent ideas." prefix="q25" onChange={this.myRef}/>
          <Question text="I have little to say." prefix="q26" onChange={this.myRef}/>
          <Question text="I have a soft heart." prefix="q27" onChange={this.myRef}/>
          <Question text="I often forget to put things back in their proper place." prefix="q28" onChange={this.myRef}/>
          <Question text="I get upset easily." prefix="q29" onChange={this.myRef}/>
          <Question text="I do not have a good imagination." prefix="q30" onChange={this.myRef}/>
          <Question text="I talk to a lot of different people at parties." prefix="q31" onChange={this.myRef}/>
          <Question text="I am not really interested in others" prefix="q32" onChange={this.myRef}/>
          <Question text="I like order." prefix="q33" onChange={this.myRef}/>
          <Question text="I change my mood a lot." prefix="q34" onChange={this.myRef}/>
          <Question text="I am quick to understand things." prefix="q35" onChange={this.myRef}/>
          <Question text="I don't like to draw attention to myself." prefix="q36" onChange={this.myRef}/>
          <Question text="I take time out for others." prefix="q37" onChange={this.myRef}/>
          <Question text="I avoid my duties." prefix="q38" onChange={this.myRef}/>
          <Question text="I have frequent mood swings." prefix="q39" onChange={this.myRef}/>
          <Question text="I use difficult words." prefix="q40" onChange={this.myRef}/>
          <Question text="I don't mind being the center of attention." prefix="q41" onChange={this.myRef}/>
          <Question text="I feel others' emotions." prefix="q42" onChange={this.myRef}/>
          <Question text="I follow a schedule." prefix="q43" onChange={this.myRef}/>
          <Question text="I get irritated easily." prefix="q44" onChange={this.myRef}/>
          <Question text="I spend time reflecting on things." prefix="q45" onChange={this.myRef}/>
          <Question text="I am quiet around strangers." prefix="q46" onChange={this.myRef}/>
          <Question text="I make people feel at ease." prefix="q47" onChange={this.myRef}/>
          <Question text="I am exacting in my work." prefix="q48" onChange={this.myRef}/>
          <Question text="I often feel blue." prefix="q49" onChange={this.myRef}/>
          <Question text="I am full of ideas." prefix="q50" onChange={this.myRef}/>
          <Question text="[Optional] Do you think you are Introverted or Extraverted? (for statistical purposes)." prefix="q74" onChange={this.myRef}/>
          <Question text="[Optional] Are you Sensing or Intuitive? (for statistical purposes)." prefix="q75" onChange={this.myRef}/>
          <Question text="[Optional] Are you Thinker or Feeler? (for statistical purposes)." prefix="q76" onChange={this.myRef}/>
          <Question text="[Optional] Are you Perceiving or Judging? (for statistical purposes)." prefix="q77" onChange={this.myRef}/>
          <Question text="Enter your gender (for statistical purposes)." prefix="q78" onChange={this.myRef}/>
          <Question text="Enter your age (for statistical purposes)." prefix="q73" onChange={this.myRef}/>


          </form>
        </div>

        {this.state.ok ? (
          <div>
          <Link
            to={"result" + "?" + this.state.extraversion +"&"+this.state.agreeablenes+"&"+this.state.constientiousness+"&"+
            this.state.emotional+"&"+this.state.intellect+"&"+ globmbti + "&" + globgen}
            state = {this.state}
            activeStyle={{ color: "red" }}
            partiallyActive={true}
            class="button"
          >Find your archetypes</Link>
          </div>
        ) : (
          <div>
          Submit button will appear here once you fill in all non-optional questions


          </div>
        )}

      </div>
    );
  }
}

export default ContactForm;
